import { useSelector } from 'react-redux'

import { useIsRecipeInBasket } from 'hooks/basket/useIsRecipeInBasket'
import { useRecipe } from 'hooks/menu-recipes/useRecipe'
import { RecipeUUID } from 'reducers/menu-recipes/recipes'
import { locationQuery } from 'selectors/routing'

export const useIsRecipeInStock = (id: RecipeUUID | null): boolean => {
  const recipe = useRecipe(id)
  const coreId = recipe?.coreId || null

  const query = useSelector(locationQuery)
  const isAdmin = !!(query && query['preview[menu_id]'])

  const isRecipeInBasket = useIsRecipeInBasket(coreId)
  const isRecipeAvailable = !!recipe?.isAvailable

  return isAdmin || isRecipeInBasket || isRecipeAvailable
}
